import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./SignIn.module.sass"; // Réutiliser les styles de SignIn
import { use100vh } from "react-div-100vh";
import { Link, useNavigate, useSearchParams } from "react-router-dom"; // Importe useSearchParams
import TextInput from "../../components/TextInput";
import Image from "../../components/Image";
import { toast } from "react-toastify";
import { pb } from "../../services/pocketbase"; 

const ConfirmPasswordReset = () => {
  const heightWindow = use100vh();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Hook pour obtenir les paramètres d'URL
  const [token, setToken] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);

  useEffect(() => {
    // Récupérer le token de l'URL
    const urlToken = searchParams.get('token');
    if (urlToken) {
      setToken(urlToken);
      console.log("Token récupéré de l'URL:", urlToken);
    } else {
      toast.error("Jeton de réinitialisation manquant dans l'URL.");
      setTimeout(() => {
        navigate('/forgot-password'); // Rediriger vers la page de demande de réinitialisation
      }, 2000);
    }
  }, [searchParams, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!token) {
      toast.error("Jeton de réinitialisation invalide ou manquant.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas.");
      setLoading(false);
      return;
    }

    try {
      // Appel à l'API PocketBase pour confirmer la réinitialisation
      await pb.collection('users').confirmPasswordReset(
        token,
        password,
        confirmPassword,
      );
      setResetSuccess(true);
      toast.success("Votre mot de passe a été réinitialisé avec succès !");
      setTimeout(() => {
        navigate('/sign-in'); // Rediriger l'utilisateur vers la page de connexion
      }, 3000); // Redirection après 3 secondes
    } catch (error) {
      console.error("Erreur lors de la confirmation de la réinitialisation:", error);
      toast.error("Échec de la réinitialisation du mot de passe. Le jeton pourrait être invalide ou expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.row}>
      <div
        className={styles.col}
        style={{
          backgroundImage: `url('/images/content/loginbg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '100vh',
          flex: 1
        }}
      />
      <div className={styles.col} style={{ minHeight: heightWindow, flex: 1.5}}>
        <div className={styles.head}>
          <Link className={styles.logo} to="/">
            <Image
              className={styles.pic}
              src="/images/logo.png"
              srcDark="/images/logo.png"
              alt="Core"
            />
          </Link>
          <div className={styles.info}>
            <Link className={styles.link} to="/sign-in">
              Retour à la connexion
            </Link>
          </div>
        </div>
        <div className={styles.wrapper}>
          <div className={cn("h2", styles.title)}>Réinitialiser votre mot de passe</div>
          <div className={styles.body}>
            {resetSuccess ? (
              <p>Votre mot de passe a été mis à jour. Vous serez redirigé vers la page de connexion dans quelques instants.</p>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextInput
                  className={styles.field}
                  name="password"
                  type="password"
                  placeholder="Nouveau mot de passe"
                  required
                  icon="lock"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <TextInput
                  className={styles.field}
                  name="confirmPassword"
                  type="password"
                  placeholder="Confirmer le nouveau mot de passe"
                  required
                  icon="lock"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  className={cn("button", styles.button)}
                  type="submit"
                  disabled={loading || !token}
                >
                  {loading ? "Réinitialisation en cours..." : "Réinitialiser le mot de passe"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmPasswordReset;